import { computed, watchEffect } from "vue";
import { usePreferredDark, useStorage } from "@vueuse/core";
import { defineStore } from "pinia";

type ThemeMode = "auto" | "light" | "dark";

const themeOptions: { value: ThemeMode; label: string }[] = [
  { value: "auto", label: "Auto" },
  { value: "light", label: "Licht" },
  { value: "dark", label: "Donker" },
];

const useTheme = defineStore("Theme", () => {
  const mode = useStorage<ThemeMode>("theme", "auto", undefined, { writeDefaults: false });
  const systemDark = usePreferredDark();

  // An explicit choice wins; `auto` follows the OS.
  const state = computed(() =>
    mode.value === "auto" ? (systemDark.value ? "dark" : "light") : mode.value,
  );

  watchEffect(() => document.documentElement.classList.toggle("dark", state.value === "dark"));

  return { mode, state };
});

export { useTheme, themeOptions };
export type { ThemeMode };
